import Button from 'components/ReusableComponents/Button'
import DragAndDropUploader from 'components/ReusableComponents/DragAndDropUploader'
import CopyIcon from 'components/ReusableComponents/Icons/CopyIcon'
import useCopyText from 'hooks/useCopyText'
import { useRef, useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

import styles from './GXPLogin.module.scss'
import { useGXPLogin } from './GXPLoginContext'

export default function ReportsCreationStep() {
  const copy = useCopyText()
  const { addToast, removeToast } = useToasts()
  const [loading, setLoading] = useState(false)
  const { data, pushToData } = useGXPLogin()

  const pondRef = useRef(null)

  const onGetOneTimePasswordClick = async () => {
    if (loading) return
    setLoading(true)
    const toastId = addToast('Getting password...', {
      appearance: 'info',
      autoDismiss: false
    })
    await pmsApi
      .getOneTimePassword({ phone: data.phoneNumber })
      .then(res => {
        copy(res)
      })
      .catch(err => {
        addToast(`${err}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        removeToast(toastId)
        setLoading(false)
      })
  }

  const onClickDone = async () => {
    if (loading) return
    setLoading(true)
    const res = await pmsApi.updateMarriotGxpConfig({ activeStep: 60 })
    pushToData(res)
    setLoading(false)
  }

  return (
    <div>
      <div className={styles.cardText}>
        <div>
          <a
            className={styles.link}
            href="https://marriottintl.my.salesforce.com/"
            target="_blank"
            rel="noreferrer"
          >
            Login to GXP
          </a>{' '}
          using these credentials:
        </div>
        <br />
        <div>
          {`Enterprise ID (EID): ${data.userName || ''}`}{' '}
          <button className={styles.copyButton} onClick={() => copy(data.userName)}>
            <CopyIcon />
          </button>
        </div>
        <div>
          {`Password: ${data.password || ''}`}
          <button onClick={() => copy(data.password)} className={styles.copyButton}>
            <CopyIcon />
          </button>
        </div>
        <br />
        <div>
          <span className={styles.link} onClick={onGetOneTimePasswordClick}>
            Click here
          </span>{' '}
          to get the one-time password. Create the reports for following Marsha codes:{' '}
          {data?.externalHotelIds?.join(', ')}. Afterward, export the onboarding data and
          upload it here. Remember to set the filters back to “Today” after getting the
          onboarding data.
        </div>
        <br />
        <div className={styles.upload}>
          <DragAndDropUploader
            labelIdle="
              <p class='filepond-p-mini'>drop files here</p>
              <span class='filepond-or'>or</span> <span class='filepond--label-action-mini'>Upload csv file</span>"
            url="/pms/upload"
            ref={pondRef}
            acceptedFileTypes={['text/csv', 'application/xml', 'text/xml']}
            onData={formData => {
              return formData
            }}
            onError={res => console.warn('file response', res)}
          />
        </div>
      </div>
      <div className={styles.actions}>
        <Button onClick={onClickDone} disabled={loading}>
          I’ve created the reports & uploaded the data
        </Button>
      </div>
    </div>
  )
}
